/**
 * Record Types
 */
export type TypeStatus = 'started' | 'unstarted' | 'complete';

export enum TypeMediaCollection {
  SKILL_SET = 'skill_set',
  COURSE = 'course',
}

export type TypeMediaCollectionRecord = {
  id: string;
  cms_id: string; // contentful CourseProduct sys id
  product_uuid: string; // playgenius product catalog uuid
  anchor: string; // playgenius product catalog anchor
  status: TypeStatus;
  created_at: string;
  updated_at: string;
};

export type TypeTokenSetRecord = {
  gif: string;
  storyboard: string;
  thumbnail: string;
  video: string;
};

export type MediaAssetType = 'Song' | 'Video';
export type TypeMediaAssetRecord = {
  id: string;
  signed: boolean;
  type: MediaAssetType;
  playback_id: string; // mux asset identifier
  cms_id: string; // contentful CourseVideo sys id
  title: string;
  created_at: string;
  updated_at: string;
};

export type TypePlaybackHistoryRecord = {
  id: string;
  media_asset_id: string;
  user_uuid: string; // playgenius account manager user
  head: number;
  created_at: string;
  updated_at: string;
  completed_at: string | null;
};

/**
 * API Request Types
 */
export type TypePlaybackHistoryRequestParams = {
  head: number;
  completed_at?: string | null;
};

export type UpdatePlaybackHistoryRequestBody = {
  playback_history: TypePlaybackHistoryRequestParams;
};

/**
 * API Response Types
 */
export type TypeResponseError = {
  ok: boolean;
  errorMessage: string;
};

export type TypeResponseSuccess<DataType> = {
  ok: boolean;
  data: DataType;
};

export type TypeCoursesResponseData = {
  courses: TypeMediaCollectionRecord[];
};

export type TypeSkillSetsResponseData = {
  skill_sets: TypeMediaCollectionRecord[];
};

export type TypeMediaAssetsResponseData = {
  media_assets: TypeMediaAssetRecord[];
};

export type TypeVideosResponseData = {
  videos: TypeMediaAssetRecord[];
};

export type TypeSongsResponseData = {
  songs: TypeMediaAssetRecord[];
};

export type TypePlaybackHistoryResponseData = {
  playback_history: TypePlaybackHistoryRecord;
};

export type TypePlaybackHistoriesResponseData = {
  playback_histories: TypePlaybackHistoryRecord[];
};

export type TypeTokenSetResponseData = {
  token_set: TypeTokenSetRecord;
};

export type TypeUserCoursesResponseSuccess =
  TypeResponseSuccess<TypeCoursesResponseData>;

export type TypeUserSkillSetsResponseSuccess =
  TypeResponseSuccess<TypeSkillSetsResponseData>;

export type TypePlaybackHistoryResponseSuccess =
  TypeResponseSuccess<TypePlaybackHistoryResponseData>;
